import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';

export default () => {
  tippy('#attributes-vegan', {
    content: 'Veganes Gericht',
  });

  tippy('#attributes-vegetarian', {
    content: 'Vegetarisches Gericht',
  });

  tippy('#attributes-spicy', {
    content: 'Kann scharf sein',
  });

  tippy('#attributes-chicken', {
    content: 'Beinhaltet Hähnchen',
  });

  tippy('#attributes-beef', {
    content: 'Beinhaltet Rindfleisch',
  });

  tippy('#attributes-fish', {
    content: 'Beinhaltet Fisch',
  });

  tippy('#attributes-lamb', {
    content: 'Beinhaltet Lamm',
  });
};
